
import NewComponent from "../../../components/events/New.vue";

export default {
  components: {
    NewComponent
  }
};
